<template>
	<div class="order-body">
		<div class="order-menu">
			代客退单
		</div>
		<div class="valet-content-body">
			<valetRefundCInfo @setValue='getValue' @setSyscodeid='setSyscodeid' @setWeChatFlag='setWeChatFlag' :shopId='shopId' ref="topPart"/>
			<MainTable :acountValue='acountValue' :orderobj='orderobj' :bigClassList='bigClassList' :shopId='shopId' :organid='organid'
			:buyersyscodeid='buyersyscodeid' @matchbillcenterflag='getmatchbillcenterflag' ref="midPart"/>
			<memoInfo :acountValue='acountValue' :orderobj='orderobj' :wechatflag='wechatflag' @express="getExpress" ref="bottomPart"/>
		</div>
		<div class="valet-foot">
			<el-button class="btn" plain type="primary" size='small' @click="goOrder">取消</el-button>
      <el-button class="btn" plain type="primary" size='small' @click="save">提交</el-button>
		</div>
	</div>
</template>

<script>
import valetRefundCInfo from '@/components/valetRefundOrder/valetRefundCInfo.vue'
import MainTable from '@/components/valetRefundOrder/MainTable.vue'
import memoInfo from '@/components/valetRefundOrder/memoInfo.vue'
export default {
	name: 'valetRefundOrder',
	components: {
		valetRefundCInfo,
		MainTable,
		memoInfo
	},
	data () {
		return {
			userinventoryflag: false,
			shopOptions: [],
			shopId: '',
			organid: '',
			orderNumber: '',
			paymentMode: '-1',
			bigClassList: [],
			buyersyscodeid: '',
			wechatflag: 0,
			unpaidInvalidTime: 2,
			orderobj: {},
			AuthorityList: {
				'07_0001_0001_00': false,
				'07_0001_0002_00': false,
				'07_0001_0003_00': false,
				'07_0001_0004_00': false,
				'07_0001_0005_00': false,
				'07_0001_0006_00': false,
				'07_0001_0007_00': false,
				'07_0001_0008_00': false,
				'07_0001_0009_00': false,
				'07_0001_0010_00': false,
				'07_0001_0011_00': false,
				'07_0001_0012_00': false,
				'07_0001_0013_00': false,
				'07_0001_0014_00': false,
				'07_0001_0015_00': false,
				'07_0001_0016_00': false,
				'07_0001_0017_00': false,
				'07_0001_0018_00': false,
				'07_0001_0019_00': false,
				'07_0001_0020_00': false,
				'07_0001_0021_00': false,
				'07_0001_0022_00': false,
				'07_0001_0025_00': false,
				'07_0001_0026_00': false,
				'07_0001_0027_00': false
			},
			acountValue: '',
			matchbillcenterflag: 0,
			express: {}
		}
	},
	created () {
		this.$fxEventBus.$emit('setMenu', '6-6')
		this.getAuthority('07_0001_0000_00')
		this.openPage()
		this.getSyestem()
	},
	methods: {
		getAuthority (data) {
			let params = {
				pId: data
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getUserAuthority`,
				data: params
			}).then(res => {
				if (res.result === true) {
					let a = res.data
					for (let i = 0; i < a.length; i++) {
						this.AuthorityList[a[i]] = true
					}
				}
			})
		},
		onCodeCopy (e) {
			this.$message.success('复制成功！')
		},
		onCodeError (e) {
			this.$message.error('复制失败！')
		},
		// 系统设置
		getSyestem () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/order/getOrderSystemSetting/`
			}).then(res => {
				if (res.result) {
					this.unpaidInvalidTime = res.data.unpaidInvalidTime
					this.userinventoryflag = res.data.userinventoryflag
				} else {
					this.$message.error(res.msg)
				}
			}).catch((res) => {
				this.$message.error(res.msg)
			})
		},
		// 获取大类
		getBigClss () {
			let data = {
				shopId: this.shopId
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/goods/getBigCategory`,
				data: data
			}).then(res => {
				if (res.result) {
					let all = { bc_name: '全部', bc_id: '' }
					res.data.unshift(all)
					this.bigClassList = res.data
				}
			}).catch(error => {
				this.$message.error(error.msg)
			})
		},
		setSyscodeid (value) {
			this.buyersyscodeid = value
		},
		setWeChatFlag (value) {
			this.wechatflag = value
		},
		openPage () {
			this.findShopList().then((data) => {
				if (data.length > 0) {
					this.shopId = data[0].shopId
					this.organid = data[0].organid
					this.shopOptions = data
					this.getBigClss()
				}
			})
		},
		findShopList () {
			return new Promise((resolve, reject) => {
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlQIVShop}/findshoplist`
				}).then(res => {
					if (res.result) {
						resolve(res.data.shop)
					} else {
						this.$message.error(res.msg)
					}
				}).catch(err => {
					this.$message.error(err.msg)
				})
			})
		},
		getValue (value, obj) {
			this.acountValue = value
			this.orderobj = obj
			this.$refs.midPart.tableData = []
		},
		goOrder () {
			let _path = `/main/order`
			this.$router.push(_path)
		},
		getmatchbillcenterflag (val) {
			this.matchbillcenterflag = val
		},
		checkNum (array) {
			for (let i = 0; i < array.length; i++) {
				let lock = true
				if (array[i].useunitflag && this.matchbillcenterflag) {
					if (array[i].refundquantity > array[i].refundMaxQuantity) {
						this.$message.error('【' + array[i].pname + '】' + '【' + array[i].spec + '】' + '最大可退' + array[i].refundMaxQuantity + array[i].punit)
						lock = false
					}
					if (+array[i].refundquantity === 0) {
						this.$message.error('【' + array[i].pname + '】' + '【' + array[i].spec + '】' + '的' + array[i].punit + '申请退货数量不能为0!')
						lock = false
					} else if (+array[i].refundassistquantity === 0) {
						this.$message.error('【' + array[i].pname + '】【' + array[i].assistunit + '】的申请退货数量不能为0！')
						lock = false
					}
					if (array[i].refundassistquantity > array[i].refundMaxAssistQuantity) {
						this.$message.error('【' + array[i].pname + '】' + '【' + array[i].spec + '】' + '最大可退' + array[i].refundMaxAssistQuantity + array[i].assistunit)
						lock = false
					}
				} else {
					if (array[i].refundquantity > array[i].refundMaxQuantity) {
						this.$message.error('【' + array[i].pname + '】' + '【' + array[i].spec + '】' + '最大可退' + array[i].refundMaxQuantity + array[i].punit)
						lock = false
					}
					if (+array[i].refundquantity === 0) {
						this.$message.error('【' + array[i].pname + '】' + '【' + array[i].spec + '】' + '的申请退货数量不能为0!')
						lock = false
					}
				}
				if (!lock) {
					return false
				}
			}
		},
		getExpress (val) {
			this.express = val
		},
		save () {
			let MainTable = this.$refs.midPart
			let tableData = MainTable.tableData
			if (this.checkNum(tableData) !== false) {
				this.submit()
			}
		},
		submit () {
			let uploadInfo = []
			let valetCInfo = this.$refs.topPart
			let MainTable = this.$refs.midPart
			let memoInfo = this.$refs.bottomPart
			if (valetCInfo.value === '' || valetCInfo.value === null) {
				this.$message.error('请选择客户!')
				return false
			}
			if (MainTable.tableData.length === 0) {
				this.$message.error('请添加商品!')
				return false
			}
			if (memoInfo.refundCause === '' || memoInfo.refundCause === null) {
				this.$message.error('请选择退款原因!')
				return false
			}
			if (memoInfo.textarea === '' || memoInfo.textarea === null) {
				this.$message.error('请填写问题描述!')
				return false
			}
			memoInfo.showSrc.forEach(e => {
				let img = {
					sourcepath: e.imgurl,
					extension: e.imgurl.split('.')[e.imgurl.split('.').length - 1]
				}
				uploadInfo.push(img.sourcepath)
			})
			let data = {
				orderid: valetCInfo.orderid,
				buyersyscodeid: this.buyersyscodeid,
				detailInfos: MainTable.tableData,
				refundway: memoInfo.refundType,
				uploadPath: uploadInfo,
				totalquantity: MainTable.tableData.length,
				finalprice: MainTable.goodsMoney,
				customerId: valetCInfo.customerid,
				cause: memoInfo.refundCause,
				memo: memoInfo.textarea,
				express: this.express
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/replacerefundorder/add`,
				data: data
			}).then(res => {
				if (res.result) {
					this.$message.success('保存成功！')
					let app = window.sessionStorage.getItem('app')
					if (app === 'scm8') {
						this.clearAll()
						let params = {
							app: 'jsd',
							action: 'goBlank',
							data: {
								path: 'main/refundOrder',
								title: '退单管理',
								biubiuorderId: 'refundOrder',
								biubiuorderMenuId: 'refundOrder',
								tabRefresh: 'true'
							}
						}
						window.parent.postMessage(params, '*')
					} else {
						let _path = `/main/refundOrder`
						this.$router.push(_path)
					}
				} else {
					this.$message.error(res.msg)
				}
			}).catch(error => {
				this.$message.error(error.msg)
			})
		},
		clearAll () {
			this.acountValue = ''
			this.$refs.topPart.clearAll()
			this.$refs.midPart.clearAll()
			this.$refs.bottomPart.clearAll()
		}
	}
}
</script>

<style lang="stylus" scoped>
.order-body {
	flex: 1
	display flex
	flex-direction column
	.shop-position {
		display flex
		align-items: center
		height: 50px
		font-size: 14px
		border-bottom: 1px solid #dce1fe
		img {
			display inline-block
			width: 20px
			height: 22px
			margin-right: 10px
		}
	}
	.icon-copy {
		color: var(--fx-primary-color);
		margin-left: 5px;
		cursor: pointer
	}
	.order-menu {
		height: 50px
		line-height: 50px
		text-indent: 30px
		text-align: left
		font-size: 15px
		border-bottom: 1px solid #dce1fe
		box-sizing: border-box
	}
	.valet-content-body {
		height: 100%;
		overflow-y: auto;
	}
	.valet-foot {
        height :40px;
        margin-bottom :10px;
        .btn{
            width :130px;
			height :35px;
			margin: 0 30px
        }
	}
	.dialog-title1 {
		text-align: left
		.el-dialog__headerbtn{
			width: 20px;
			height: 20px;
			border-radius: 50%;
			background-color: red;
			line-height: 20px;
			.el-icon-close{
				color:#fff
			}
		}
	}
}
</style>
<style lang="stylus">
.dialog-title1 {
	.el-dialog__body {
		padding-top: 20px
		max-height: 550px;
		overflow-y: auto;
	}
}
.dialog-title2 {
	text-align: left;
	.el-dialog__footer {
		text-align: center
	}
}
.dialog-title3 {
	text-align: left;
	.el-dialog__body {
		padding: 10px 20px;
	}
}
</style>
